interface params { }

export function EmptyData(params: params) {
  return (
    <div className='w-100 h-100 d-flex justify-content-center'>
      <p className='text-muted'>Sin Datos</p>
    </div>
  )
}